import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { IMapSettingState } from 'sustainment-component';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'mapSetting' })
export class MapSettingStore extends Store<IMapSettingState> {
  private constructor() {
    super({ mapSetting: undefined, viewType: 'list' });
  }
}
